export default __webpack_public_path__ + "b5ab62bebfe1238581f20ce236ef8646.png";